var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-spinner',{style:({ width: `${_vm.size}rem`, height: `${_vm.size}rem` }),attrs:{"variant":_vm.variant,"type":_vm.type,"label":"Loading"}})
}
var staticRenderFns = []

export { render, staticRenderFns }